/* eslint-disable import/prefer-default-export */
import client from 'core/axios';

import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getFAFSAStatus = ({ studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/student/${studentId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getDistrictFAFSAList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/fafsa/district`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSACompletionStatus = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/district/completion-status`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSAShowSubmittedDate = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/district/show-submitted-date`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSAStudentChoices = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/status`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSAStudentUpdateHistory = ({ studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/student/${studentId}/update-history`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const bulkUpdateStudentFAFSAStatus = ({ payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/district/update-status`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSACompletionEvidenceZip = ({
  params = {},
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/fafsa/completion-evidence-zip`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFAFSACompletionReportCSV = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/completion-report-csv`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFinancialAidFormRequirementSetting = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/financial-aid-form-requirement-setting/me`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentFAFSAStatus = ({ studentId, data, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/student/${studentId}/update-status/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentFileUploadIndicator = ({
  studentId,
  usage,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/fafsa/student/${studentId}/file-upload-indicator/`,
      method: RequestMethod.POST,
      data: { usage: [usage] },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFileUploadId = ({ studentId, usage, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/student/${studentId}/get-file-upload-indicator/`,
      method: RequestMethod.POST,
      data: { usage: [usage] },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentsHash = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `${version}/fafsa/district/students-hash`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
